export default class MapboxService {
  serviceURL = "https://api.mapbox.com/styles/v1/mapbox";

  getStaticImageURL(
    lon: number,
    lat: number,
    zoom: number,
    width: number,
    height: number
  ): string {
    return (
      this.serviceURL +
      `/light-v10/static/${lon},${lat},${zoom},0/${width}x${height}` +
      `?access_token=${process.env.VUE_APP_MAP_ACCESS_TOKEN}`
    );
  }
}
